import API from 'API'

const UNAUTHORIZED_CODE = 401
const FORBIDDEN_CODE = 403
const INTERNAL_SERVER_ERROR_CODE = 500

export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_HANDLE_LOGOUT = 'SET_HANDLE_LOGOUT'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const SUCCESS_LOAD_PERMISSION = 'SUCCESS_LOAD_PERMISSION'
export const BLOCK_ACCESS = 'BLOCK_ACCESS'
export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR'

export const setUserData = data => {
  const {userName, name} = data
  return {
    type: SET_USER_DATA,
    data: {userName, name},
  }
}

export const setLogout = handleLogout => {
  if (typeof handleLogout !== 'function') return

  return {
    type: SET_HANDLE_LOGOUT,
    data: handleLogout,
  }
}

export const getUserPermission = () => dispatch => {
  API.getAuth()
    .then(({data}) => {
      dispatch({type: SUCCESS_LOAD_PERMISSION, data})
    })
    .catch(error => {
      const status = error?.response?.status || error?.status || error?.code
      const isNetworkError =
        error?.message === 'Network Error' ||
        error?.code === 'NETWORK_ERROR' ||
        error?.code === 'ECONNABORTED' ||
        !error?.response

      if (status === UNAUTHORIZED_CODE || status === FORBIDDEN_CODE) {
        dispatch({
          type: BLOCK_ACCESS,
          data: true,
        })
      } else if (status === INTERNAL_SERVER_ERROR_CODE) {
        dispatch({
          type: INTERNAL_SERVER_ERROR,
          data: true,
        })
      } else if (isNetworkError) {
        // Network error - no internet connection, timeout, etc.
        console.error('Network error detected:', error.message)
        dispatch({
          type: INTERNAL_SERVER_ERROR,
          data: true,
        })
      } else {
        // Other errors - we also block access
        console.error('Falling back to BLOCK_ACCESS for status:', error.message)
        dispatch({
          type: BLOCK_ACCESS,
          data: true,
        })
      }
    })
}
